export default "__VITE_ASSET__1207d781__"